import { stringify } from 'qs';

interface SerializeQueryParamsOptions {
  addQueryPrefix?: boolean;
}

/**
 * Converts object to query string.
 *
 * @example { k1: 'v1', k2: 'v2' } => ?k1=v1&k2=v2
 */
export const serializeQueryParams = (
  queryParams: Record<string, unknown>,
  options?: SerializeQueryParamsOptions
) => {
  const actualQueryParams: Record<string, unknown> = {};
  Object.keys(queryParams).forEach((key) => {
    const value = queryParams[key];
    if (value || value === 0) actualQueryParams[key] = value;
  });
  return stringify(actualQueryParams, {
    encodeValuesOnly: true,
    arrayFormat: 'brackets',
    ...options,
  });
};
